import {
  APP_SETTING_ADD_PROJECT_ROBOTS_TXT_BEGIN,
  APP_SETTING_ADD_PROJECT_ROBOTS_TXT_SUCCESS,
  APP_SETTING_ADD_PROJECT_ROBOTS_TXT_FAILURE,
  APP_SETTING_ADD_PROJECT_ROBOTS_TXT_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function addProjectRobotsTxt(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_ADD_PROJECT_ROBOTS_TXT_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/robotsTxt`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: APP_SETTING_ADD_PROJECT_ROBOTS_TXT_SUCCESS,
              data: res.data,
            });
            toast.success('Saved Successfully !', {});
            resolve(res);
          } else {
            dispatch({
              type: APP_SETTING_ADD_PROJECT_ROBOTS_TXT_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_ADD_PROJECT_ROBOTS_TXT_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissAddProjectRobotsTxtError() {
  return {
    type: APP_SETTING_ADD_PROJECT_ROBOTS_TXT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_ADD_PROJECT_ROBOTS_TXT_BEGIN:
      return {
        ...state,
        addProjectRobotsTxtPending: true,
        addProjectRobotsTxtError: null,
      };

    case APP_SETTING_ADD_PROJECT_ROBOTS_TXT_SUCCESS:
      return {
        ...state,
        addProjectRobotsTxtPending: false,
        addProjectRobotsTxtError: null,
        projectDetail: action.data,
      };

    case APP_SETTING_ADD_PROJECT_ROBOTS_TXT_FAILURE:
      return {
        ...state,
        addProjectRobotsTxtPending: false,
        addProjectRobotsTxtError: action.data.error,
      };

    case APP_SETTING_ADD_PROJECT_ROBOTS_TXT_DISMISS_ERROR:
      return {
        ...state,
        addProjectRobotsTxtError: null,
      };

    default:
      return state;
  }
}
